import React, { useRef, useState } from "react";
import SingleVideo from "../HomePage/SingleVideo";
import {
  Box,
  Typography,
  Card,
  CardContent,
  Divider,
  Link,
  List,
  ListItem,
  ListItemText,
} from "@mui/material";

const ReportedContent = ({ reports, markPostActive, markPostInactive }) => {
  const [currentPlayingIndex, setCurrentPlayingIndex] = useState(null);
  const videoRefs = useRef([]);

  const handlePlayPause = (index) => {
    videoRefs.current.forEach((video, i) => {
      if (video && i !== index) {
        video.pause();
      }
    });

    if (currentPlayingIndex === index) {
      videoRefs.current[index].pause();
      setCurrentPlayingIndex(null);
    } else {
      videoRefs.current[index].play();
      setCurrentPlayingIndex(index);
    }
  };

  if (!reports?.length) return <Typography>No reports found.</Typography>;

  return (
    <Box p={2}>
      <Typography variant="h4" gutterBottom>
        Reported Content
      </Typography>
      {reports.map((report, index) => (
        <Card key={report.id} sx={{ mb: 3, p: 2 }}>
          <CardContent>
            <Box
              display="flex"
              justifyContent="space-between"
              fontSize={14}
              color="text.secondary"
            >
              <span>Report ID: {report.id}</span>
              <span>{new Date(report.createdAt).toLocaleString()}</span>
            </Box>

            <Typography variant="subtitle1" sx={{ mt: 1 }}>
              Reporter: {report.reporter?.firstName} {report.reporter?.lastName}{" "}
              ({report.reporter?.email})
            </Typography>

            <Typography variant="body1" sx={{ mt: 1 }}>
              Message: <strong>{report.message}</strong>
            </Typography>

            {report.reportedContent ? (
              <Box
                mt={2}
                p={2}
                border={1}
                borderColor="grey.300"
                borderRadius={2}
                bgcolor="grey.50"
              >
                <Typography fontWeight="bold">Reported Content:</Typography>
                <Typography variant="body2">
                  Title: {report.reportedContent.title} <br />
                  Description: {report.reportedContent.description} <br />
                  Tags: {report.reportedContent.tags?.join(", ")}
                </Typography>
                <Box mt={2}>
                  <SingleVideo
                    item={report.reportedContent}
                    videoRef={(ref) => (videoRefs.current[index] = ref)}
                    onPlayPause={() => handlePlayPause(index)}
                    isPlaying={currentPlayingIndex === index}
                    paid={true}
                    markPostActive={markPostActive}
                    markPostInactive={markPostInactive}
                  />
                </Box>
              </Box>
            ) : (
              <Typography color="error" sx={{ mt: 2 }}>
                No linked content.
              </Typography>
            )}

            {report.attachments?.length > 0 && (
              <Box mt={2}>
                <Typography fontWeight="bold">Attachments:</Typography>
                <List dense>
                  {report.attachments.map((url, idx) => (
                    <ListItem key={idx} disableGutters>
                      <ListItemText>
                        <Link
                          href={url}
                          target="_blank"
                          rel="noopener noreferrer"
                        >
                          {url.split("/").pop()}
                        </Link>
                      </ListItemText>
                    </ListItem>
                  ))}
                </List>
              </Box>
            )}
          </CardContent>
        </Card>
      ))}
    </Box>
  );
};

export default ReportedContent;
